import AsControl from '../AsControl';
import bindControlToForm from '../../utils/hoc/formHelpers/bindControlToForm';
import { TimePicker as BaseTimePicker } from './TimePicker';

const TimePicker = AsControl()(BaseTimePicker);
const TimePickerControl = bindControlToForm()(TimePicker);

export {
  TimePicker,
  TimePickerControl,
};
